<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            Change Email
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="px-2">
            <ValidationProvider v-slot="{ errors, valid }" name="current_email" rules="required|email">
              <v-text-field v-model="form.old_email" type="email" label="Current Email" color="primary" :error-messages="errors" />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors, valid }" name="email" rules="required|email">
              <v-text-field v-model="form.new_email" type="email" label="New Email" color="primary" :error-messages="errors" />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors, valid }" name="password" rules="required|min:8">
              <v-text-field v-model="form.password" :type="visibility ? 'text' : 'password'" label="Password" color="primary" :error-messages="errors" :append-icon="visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="visibility = !visibility" />
            </ValidationProvider>
            <v-btn color="primary" x-large block class="text-none" @click="changePassword">
              Save
            </v-btn>
          </v-form>
        </ValidationObserver>
        <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
          {{ dataSuccess.message }}
          <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  changeEmail as changeEmailCustomer
} from '@/api/customer'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      visibility: false,
      form: {
        old_email: '',
        new_email: '',
        password: ''
      }
    }
  },
  methods: {
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    async changePassword() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          await changeEmailCustomer(this.form)
          this.$store.state.loading_axios = false
          this.dataSuccess.show = true
          this.dataSuccess.message = 'Sukses mengganti email'
          setTimeout(() => {
            const astra_outlet = this.$store.state.store_astra
            const tmii_outlet = this.$store.state.store_tmii
            const url_id = this.$store.state.url_domain

            if (tmii_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://order.kulinertmii.id'
            } else if (astra_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://zestloungemenaraastra.myolsera.com'
            } else {
              this.$router.push({ name: 'home' }).catch(() => {})
            }
          }, 3000)
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
